import getPlansByProductId from 'core/services/getPlansByProductId'
import curry from 'utils/functional/curry'
import {
  DENTAL,
  VISION,
  LATITUDE,
  ECONOMY,
  QUANTUM,
  DELUXE,
  STANDARD,
  CORE,
  CHOICE,
  EPIC,
  SUPPLEMENTAL_BENEFIT,
  SURE_CARE
  // AMERITAS_DENTAL,
  // AMERITAS_VISION
} from 'core/constants/products'
import { PANAM_ENABLED } from 'core/constants/environment'

const products = [
  DENTAL,
  VISION,
  LATITUDE,
  ECONOMY,
  QUANTUM,
  DELUXE,
  STANDARD,
  CORE,
  CHOICE,
  EPIC,
  SUPPLEMENTAL_BENEFIT
  // AMERITAS_DENTAL,
  // AMERITAS_VISION
]

if (PANAM_ENABLED) products.push(SURE_CARE)

const getSTM = curry(getPlansByProductId)({
  products: products
})

export default getSTM
